import { render, staticRenderFns } from "./waste_input.vue?vue&type=template&id=cd76133e&scoped=true&"
import script from "./waste_input.vue?vue&type=script&lang=js&"
export * from "./waste_input.vue?vue&type=script&lang=js&"
import style0 from "./waste_input.vue?vue&type=style&index=0&id=cd76133e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd76133e",
  null
  
)

export default component.exports